import { ModeVariant } from '@sternum/web/features/appContainerWithMenu/models';

import { MarketingBlockForSandbox } from './MarketingBlockForSandbox.component';
import { MarketingBlockForTrial } from './MarketingBlockForTrial.component';

interface ModeMarketingBlockProps {
  variant: ModeVariant;
}

export function MarketingBlock({ variant }: ModeMarketingBlockProps) {
  if (variant === 'sandbox') {
    return <MarketingBlockForSandbox />;
  }

  if (variant === 'trial') {
    return <MarketingBlockForTrial />;
  }
}
